import {Kite} from "./Kite";
import {Button} from "@mui/material";
import {CreateKiteDialog} from "./CreateKiteDialog";
import React, {useState} from "react";
import DeleteDialog from "../molcules/Dialogs/DeleteDialog";
import {CloneKiteDialog} from "./CloneKiteDialog";

export const KiteList = ({kites, kiteTemplates, isLoading, triggerCreateKite, deleteKite, cloneKite, editKite = true, siteNormalName}) => {
  const [open, setOpen] = useState(false);
  const [cloneOpen, setCloneOpen] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [selectedKite, setSelectedKite] = useState({});
  const [makeTemplateMode, setMakeTemplateMode] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const openCreateKite = () => {
    setOpen(true);
  }

  const onDeleteKite = (e, kite) => {
    setSelectedKite(kite);
    setShowDelete(true);
  }

  const openCloneKite = (e, kite, makeTemplate = false) => {
    setCloneOpen(true);
    setSelectedKite(kite);
    setMakeTemplateMode(makeTemplate);
  }

  const onCloneKite = (kiteOptions) => {
    cloneKite(selectedKite, kiteOptions);
  }

  return (<div style={{paddingTop:14}}>
    {kites && !isLoading &&
      <React.Fragment>
        {deleteKite && <DeleteDialog
          heading={'Are you sure you want to delete this kite?'}
          show={showDelete}
          onDelete={() => {
            deleteKite(selectedKite);
            setShowDelete(false);
          }}
          onClose={() => setShowDelete(false)}
        />}

        <div style={{
          display: 'flex',
          gap:8,
          flexWrap: 'wrap',
        }}>
          {kites.map((kite, index) => <Kite kite={kite} key={index} deleteKite={deleteKite ? onDeleteKite : undefined} cloneKite={cloneKite ? openCloneKite : undefined} editKite={editKite} siteNormalName={siteNormalName} />)}

          {triggerCreateKite && <Button
            onClick={() => {
              openCreateKite();
            }}
            variant={'outlined'}
            color={'primary'}>Add New Kite</Button>}
        </div>
        {triggerCreateKite && <CreateKiteDialog
          triggerCreateKite={triggerCreateKite}
          kiteTemplates={kiteTemplates}
          open={open}
          handleClose={handleClose} />}

        {cloneKite && <CloneKiteDialog
          triggerCloneKite={onCloneKite}
          open={cloneOpen}
          handleClose={() => {
            setCloneOpen(false);
            setMakeTemplateMode(false);
          }}
          makeTemplate={makeTemplateMode}
        />}
      </React.Fragment>
    }
  </div>)
}
